import { Link } from "gatsby";
import React, { Component } from "react"
import Layout from "../components/layout";
import "../css/sharan-style.css";
import "../css/style.css";
import "../css/animate.min.css";
import "../css/responsive.css";
import "../css/bootstrap.min.css";
import "../css/swiper-bundle.min.css";
import PopupForm from "./popupForm";
import LiveChat from 'react-livechat'
import ReactGA from 'react-ga'

class Header  extends Component {
    constructor(props) {
        super(props);
        this.state ={
            click:false,
            time: 90000000
        }
        this.myFunction = this.myFunction.bind(this)
        this.hamFunction = this.hamFunction.bind(this)
    }

    componentDidMount() {
        ReactGA.initialize('UA-188856748-1')
    }   
    
    hamFunction=()=>
    {
        this.setState({click: !this.state.click})
    }

    myFunction=()=>
    {
       var element = document.querySelector(".explore-menu");
         element.classList.toggle("active");
    }

    myFunction1=()=> {
        
    var element = document.getElementById("explore-country1");
    var element11 = document.getElementById("fireing");
    // added by ninganagouda
    var element12 = document.getElementById("fireing1");
    var element13 = document.getElementById("fireing3");
    var element14 = document.getElementById("fireing4");

    var element2 = document.getElementById("explore-country2");

    var element3 = document.getElementById("price-menu4");
    var element4 = document.getElementById("explore-country3");
    element11.classList.toggle("active");
    element.classList.toggle("active");
    element2.classList.remove("active");
    element3.classList.remove("active");
    element4.classList.remove("active");

    // added by ninganagouda
    element12.classList.remove("active");
    element13.classList.remove("active");
    element14.classList.remove("active");

}

sportsFunction=()=>{
    var elementsports = document.getElementById("Sprtsfunction");
    var elementtech = document.getElementById("tech-function");
    var element2 = document.getElementById("explore-country2");
    var element3 = document.getElementById("price-menu3");
    var element4 = document.getElementById("explore-country3");
    var element113 = document.getElementById("nearbyfire3");
    elementsports.classList.toggle("active");
    elementtech.classList.remove("active");
    element2.classList.remove("active");
    element3.classList.remove("active");
    element4.classList.remove("active");
    element113.classList.remove("active");
}
techFunction=()=>{
    var elementsports = document.getElementById("Sprtsfunction");
    var element3 = document.getElementById("price-menu3");
    element3.classList.remove("active");
    var elementtech = document.getElementById("tech-function");
    elementtech.classList.toggle("active");
    elementsports.classList.remove("active");
}
UkBusinessFunction=()=>{
    var elementUkBusiness = document.getElementById("UkBussiness");
    var elementUkCommerce = document.getElementById("UkCommerce");
    elementUkBusiness.classList.toggle("active");
    elementUkCommerce.classList.remove("active");
}
UkCommerceFunction=()=>{
    var elementUkBusiness = document.getElementById("UkBussiness");
    var elementUkCommerce = document.getElementById("UkCommerce");
    elementUkCommerce.classList.toggle("active");
    elementUkBusiness.classList.remove("active");
}
UkBusinessFunction1=()=>{
    var elementUkBusiness1 = document.getElementById("fireing4");

    var element212 = document.getElementById("fireing3");


    element212.classList.remove("active");


    elementUkBusiness1.classList.toggle("active");
}
bussinesFunction1mob=()=>{
    var element111 = document.getElementById("nearbyfire");
    var element1 = document.getElementById("price-menu1-mob");
    var element2 = document.getElementById("price-menu2-mob");
    var element3 = document.getElementById("price-menu3-mob");
   
    element111.classList.toggle("active");
    element1.classList.toggle("active");
    element2.classList.remove("active");
    element3.classList.remove("active");
}
DubaiCommerceFun=()=>{
    var elementDubaiCommerce = document.getElementById("Dubaicommerce");
    var elemntDubaiBussiness = document.getElementById("price-menu4");
    elementDubaiCommerce.classList.toggle("active"); 
    elemntDubaiBussiness.classList.remove("active");
}
 bussinesFunction1=()=> {
   
    var element111 = document.getElementById("nearbyfire");

    // added by gouda
    var element112 = document.getElementById("nearbyfire2");
    var element113 = document.getElementById("nearbyfire3");
    var element114 = document.getElementById("Sprtsfunction");
    var element115 = document.getElementById("tech-function");

    var element1 = document.getElementById("price-menu1");
    var element2 = document.getElementById("price-menu2");
    var element3 = document.getElementById("price-menu3");
    element111.classList.toggle("active");
    element1.classList.toggle("active");
    element2.classList.remove("active"); 
    element3.classList.remove("active");


    // added by gouda
    element112.classList.remove("active");
    element113.classList.remove("active");
    element114.classList.remove("active"); 
    element115.classList.remove("active");


}

bussinesFunction2mob=()=> {
    var element111 = document.getElementById("nearbyfire");
    var element112 = document.getElementById("nearbyfire2");
    var element1 = document.getElementById("price-menu1-mob");
    var element2 = document.getElementById("price-menu2-mob");
    var element3 = document.getElementById("price-menu3-mob");
    element112.classList.toggle("active");
    element111.classList.remove("active");
    element1.classList.remove("active");
    element2.classList.toggle("active");
    element3.classList.remove("active");
}

 bussinesFunction2=()=> {
    var element111 = document.getElementById("nearbyfire");
    var element1 = document.getElementById("price-menu1");
    var element2 = document.getElementById("price-menu2");
    var element3 = document.getElementById("price-menu3");

  // added by gouda
  var element112 = document.getElementById("nearbyfire2");
  var element113 = document.getElementById("nearbyfire3");
  var element114 = document.getElementById("Sprtsfunction");
  var element115 = document.getElementById("tech-function");


    element112.classList.toggle("active");
    element111.classList.remove("active");
    element1.classList.remove("active");
    element2.classList.toggle("active");
    element3.classList.remove("active");

        // added by gouda
        element111.classList.remove("active");
        element113.classList.remove("active");
        element114.classList.remove("active"); 
        element115.classList.remove("active");
    
}

bussinesFunction3mob=()=> {
    var element111 = document.getElementById("nearbyfire");
    var element112 = document.getElementById("nearbyfire2");
    var element113 = document.getElementById("nearbyfire3");
    var element1 = document.getElementById("price-menu1-mob");
    var element2 = document.getElementById("price-menu2-mob");
    var element3 = document.getElementById("price-menu3-mob");
    element113.classList.toggle("active");
    element111.classList.remove("active");
    element112.classList.remove("active");
    element1.classList.remove("active");
    element2.classList.remove("active");
    element3.classList.toggle("active");
}

 bussinesFunction3=()=> {
    var element111 = document.getElementById("nearbyfire");
    var element112 = document.getElementById("nearbyfire2");
    var element113 = document.getElementById("nearbyfire3");
    var element1 = document.getElementById("price-menu1");
    var element2 = document.getElementById("price-menu2");
    var element3 = document.getElementById("price-menu3");
        var elementsports = document.getElementById("Sprtsfunction");
    element113.classList.toggle("active");
    element111.classList.remove("active");
    element112.classList.remove("active");
    element1.classList.remove("active");
    element2.classList.remove("active");
    element3.classList.toggle("active");
    elementsports.classList.remove("active");
}
/******** DROPDOWN 2 **************/
 myFunction2=()=> {
    var element = document.getElementById("explore-country1");
    var element1 = document.getElementById("price-menu1");
    var element2 = document.getElementById("price-menu2");
    var element3 = document.getElementById("price-menu3");
    var element4 = document.getElementById("explore-country2");
    var element5 = document.getElementById("explore-country3");

// added by ninganagouda

    var element13 = document.getElementById("fireing3");
    var element14 = document.getElementById("fireing4");



    var element211 = document.getElementById("fireing1");
    var element221 = document.getElementById("fireing");



    element211.classList.toggle("active");
    element221.classList.remove("active");
    element.classList.remove("active");
    element1.classList.remove("active");
    element2.classList.remove("active");
    element3.classList.remove("active");
    element4.classList.toggle("active");
    element5.classList.remove("active");

    element13.classList.remove("active");
    element14.classList.remove("active");

}

 analyticFunction=()=> {
    var element = document.getElementById("price-menu4");
    element.classList.toggle("active");
    var element213 = document.getElementById("nearbyfire4");
    element213.classList.toggle("active");
    var elementDubaiCommerce = document.getElementById("Dubaicommerce");
    elementDubaiCommerce.classList.remove("active");
}

 analyticFunctionmob=()=> {
    var element = document.getElementById("price-menu4-mob");
    element.classList.toggle("active");
    var element213 = document.getElementById("nearbyfire4");
    element213.classList.toggle("active");
    var elementDubaiCommerce = document.getElementById("Dubaicommerce");
    elementDubaiCommerce.classList.remove("active");
}
/******** DROPDOWN 3 **************/
 myFunction3=()=> {
    var element = document.getElementById("explore-country1");
    var element1 = document.getElementById("price-menu1");
    var element2 = document.getElementById("price-menu2");
    var element3 = document.getElementById("price-menu3");
    var element4 = document.getElementById("explore-country2");
    var element5 = document.getElementById("price-menu4");
    var element6 = document.getElementById("explore-country3");


    var element212 = document.getElementById("fireing3");
    var element211 = document.getElementById("fireing1");
    var element221 = document.getElementById("fireing");

    // added by ninganagouda
    var element14 = document.getElementById("fireing4");



    element212.classList.toggle("active");
    element211.classList.remove("active");
    element221.classList.remove("active");
    element14.classList.remove("active");


    element.classList.remove("active");
    element1.classList.remove("active");
    element2.classList.remove("active");
    element3.classList.remove("active");
    element4.classList.remove("active");
    element5.classList.remove("active");
    element6.classList.toggle("active");


}


/******** DROPDOWN 4 **************/
 myFunction4=()=> {
    var element = document.getElementById("explore-country1");
    var element1 = document.getElementById("price-menu1");
    var element2 = document.getElementById("price-menu2");
    var element3 = document.getElementById("price-menu3");
    var element4 = document.getElementById("explore-country2");
    var element5 = document.getElementById("price-menu4");
    var element6 = document.getElementById("explore-country3");


    var element312 = document.getElementById("fireing4");
    var element212 = document.getElementById("fireing3");
    var element211 = document.getElementById("fireing1");
    var element221 = document.getElementById("fireing");


    element312.classList.toggle("active");
    element212.classList.remove("active");
    element211.classList.remove("active");
    element221.classList.remove("active");


    element.classList.remove("active");
    element1.classList.remove("active");
    element2.classList.remove("active");
    element3.classList.remove("active");
    element4.classList.remove("active");
    element5.classList.remove("active");
    element6.classList.toggle("active");
}

EngishPrep = () => {
    let element1 = document.getElementById("explore-country1");
    let element2 = document.getElementById("explore-country2");
    let element3 = document.getElementById("fireing4");
    let element4 = document.getElementById("explore-country3");

    element1.classList.remove("active")
    element2.classList.remove("active")
    element3.classList.toggle("active")
    element4.classList.remove("active")
}

InstitutionsFunction = () => {
    let element = document.getElementById("programs-menu")

    element.classList.remove("active")
}

handelsubmit=()=>
{
    this.props.history.push({ pathname:'/programlisting' ,search: "country=Australia", state:{ Country:"Australia" }});
 
}

handlePopupWindow = () => {
    this.setState({ time: Math.random()})
}

handleTimeChange = () => {
    this.setState({time: Math.random()})
}
 


  render(){
    return(
        <div class="wrapper"> 
        {
            typeof window !== 'undefined' && <LiveChat license={13002087} />
        }
        <PopupForm time={this.state.time} handleTimeChange = {this.handleTimeChange} />
        <header class="Header-custom-styling">
        <div class="container">
            <div class="row">
                <div class="col-12"> 
                    <div class="navigation">
                        <nav class="navbar navbar-expand-lg navbar-light">
                                    <a class="navbar-brand" href="/"><img src="https://media.publit.io/file/TheWorldgrad/HeaderCommon/logo_iqhntc.svg" alt="" /></a>  
                            {/* <div onClick={()=>this.hamFunction()}> */}
                            {/* <input onClick={()=>this.hamFunction()} type="checkbox" id="#lua-navbar-toggler" class="d-none" /> 
                            <label onClick={()=>this.hamFunction()} for="lua-navbar-toggler" class="navbar-toggler" data-toggle="collapse" data-target="#lua-navbar-content" aria-controls="lua-navbar-content" aria-expanded="false" aria-label="Toggle navigation">
                                <span onClick={()=>this.hamFunction()} class="navbar-toggler-icon"> </span>
                                <span onClick={()=>this.hamFunction()} class="navbar-toggler-icon"> </span>
                                <span onClick={()=>this.hamFunction()} class="navbar-toggler-icon"> </span>
                            </label> */}
                              <input type="checkbox" id="#lua-navbar-toggler" class="d-none" /> 
                            <label onClick={()=>this.hamFunction()} for="lua-navbar-toggler" class="navbar-toggler" data-toggle="collapse" data-target="#lua-navbar-content" aria-controls="lua-navbar-content" aria-expanded="false" aria-label="Toggle navigation">
                                <span class="navbar-toggler-icon"> </span>
                                <span  class="navbar-toggler-icon"> </span>
                                <span  class="navbar-toggler-icon"> </span>
                            </label>
                            {/* </div>  */}
                            <div className={"collapse navbar-collapse" + " " +(this.state.click == true ? 'WGdisplayClass' : 'WGdisplayNoneClass')} id="navbarSupportedContent">
                                <ul class="navbar-nav ml-auto"> 
                                   
                                {/* <li class="nav-item">
                                                <a class="nav-link" href="#">Programs <img src="https://media.publit.io/file/TheWorldgrad/HeaderCommon/down-arrow_hndcah.svg" alt="" /></a>
                                        <div class="submenu">
                                            <ul className="text-left">
                                                <li><a href="/unismarter/"
                                                    onClick={() => {
                                                        ReactGA.event({
                                                            category: "Home Page",
                                                            action: "Filter>Clicks",
                                                            label: "Unismarter"
                                                        })
                                                    }}
                                                >UNISMARTER</a></li>
                                                <li><a href="/americandream/"
                                                    onClick={() => {
                                                        ReactGA.event({
                                                            category: "Home Page",
                                                            action: "Filter>Clicks",
                                                            label: "American Dream"
                                                        })
                                                    }}
                                                >ALL AMERICAN YEAR 1 PROGRAM</a></li>
                                                <li><a href="/blogs">BLOGS & RESOURCES</a></li>
                                                <li><a href="/goa/"
                                                    onClick={() => {
                                                        ReactGA.event({
                                                            category: "Home Page",
                                                            action: "Filter>Clicks",
                                                            label: "GOA"
                                                        })
                                                    }}
                                                >GLOBAL ONLINE ACCELERATOR PROGRAM</a></li>
                                            </ul>
                                        </div>
                                    </li>  */}

                                     <li class="nav-item">
                                        
                                                <a class="nav-link" href="/#" onMouseOver={() => this.myFunction()} > Courses <img src="https://media.publit.io/file/TheWorldgrad/HeaderCommon/down-arrow_hndcah.svg" alt="" /></a>
                                    
                                                <div class="explore-menu" id="programs-menu">
                                                    <div onMouseLeave={() => this.InstitutionsFunction()} class="explore-nav" id="programs-explore-nav">
                                                        <ul>
                                                        {/* onClick={()=>this.handelsubmit()} */}
                                                            <li>
                                                                <a 
                                                                    href="/program-listing/?Country=Australia&categoryname=all&DegreeType=all"   
                                                                    onMouseOver={()=>this.myFunction1()} 
                                                                    id="fireing" 
                                                                    class="desk-fireing"
                                                                >   
                                                                    Australia 
                                                                    <img src="https://res.cloudinary.com/worldgrad/image/upload/v1612202440/worldgrad/right-arrow_ny7ss3.svg" alt="" />
                                                                </a>

                                                                <a 
                                                                    href="/program-listing/?Country=Australia&categoryname=all&DegreeType=all" 
                                                                    class="mob-fireing widh-ext" 
                                                                    id="fireing"
                                                                    onClick={() => {
                                                                        ReactGA.event({
                                                                            category: "Home Page",
                                                                            action: "Clicks",
                                                                            label: "Programs-Australia"
                                                                        })
                                                                    }} 
                                                                >
                                                                    Australia 
                                                                </a> 
                                                                <img src="https://res.cloudinary.com/worldgrad/image/upload/v1612202440/worldgrad/right-arrow_ny7ss3.svg" class="aus-arrow" onClick={()=>this.myFunction1()}  alt="" />
                                                                <div id="explore-country1" class="explore-country">
                                                                    <ul>
                                                                        <li class="desk-fireing">
                                                                        <a 
                                                                            href="/program-listing/?Country=Australia&categoryname=Business %26 Analytics&DegreeType=all" onSelect={()=>this.storingAusDetails} 
                                                                            onMouseOver={()=>this.bussinesFunction1()} id="nearbyfire"
                                                                            onClick={() => {
                                                                                ReactGA.event({
                                                                                    category: "Home Page",
                                                                                    action: "Clicks",
                                                                                    label: "Programs - Australia - Business & Analytics"
                                                                                })
                                                                            }} 
                                                                        >
                                                                            Business & Analytics  
                                                                            <img src="https://res.cloudinary.com/worldgrad/image/upload/v1612202440/worldgrad/right-arrow_ny7ss3.svg" alt="" />
                                                                        </a>
                                                                            <div id="price-menu1" class="explore-price-menu">
                                                                                <ul>
                                                                                    <li>
                                                                                        <a 
                                                                                            href="/program-listing/?Country=Australia&categoryname=Business %26 Analytics&DegreeType=Undergraduate"
                                                                                            onClick={() => {
                                                                                                ReactGA.event({
                                                                                                    category: "Home Page",
                                                                                                    action: "Clicks",
                                                                                                    label: "Programs - Australia - Business & Analytics - UG"
                                                                                                })
                                                                                            }} 
                                                                                        >
                                                                                            UG
                                                                                        </a>
                                                                                    </li>
                                                                                    <li>
                                                                                        <a 
                                                                                            href="/program-listing/?Country=Australia&categoryname=Business %26 Analytics&DegreeType=Postgraduate"
                                                                                            onClick={() => {
                                                                                                ReactGA.event({
                                                                                                    category: "Home Page",
                                                                                                    action: "Clicks",
                                                                                                    label: "Programs - Australia - Business&Analytics - PG"
                                                                                                })
                                                                                            }}
                                                                                        > 
                                                                                            PG
                                                                                        </a>
                                                                                    </li>
                                                                                </ul>
                                                                            </div>
                                                                        </li>


                                                                          <li class="mob-fireing">
                                                                          <a href="/program-listing/?Country=Australia&categoryname=Business %26 Analytics&DegreeType=all"  
                                                                          >Business & Analytics </a> 
                                                                          <img src="https://res.cloudinary.com/worldgrad/image/upload/v1612202440/worldgrad/right-arrow_ny7ss3.svg"   onClick={()=>this.bussinesFunction1mob()} onSelect={()=>this.storingAusDetails} id="nearbyfire" class="business-arrow" alt="" />  
                                                                            <div id="price-menu1-mob" class=" explore-price-menu">
                                                                                <ul>
                                                                                    <li><a href="/program-listing/?Country=Australia&categoryname=Business %26 Analytics&DegreeType=Undergraduate">UG</a></li>
                                                                                    <li><a href="/program-listing/?Country=Australia&categoryname=Business %26 Analytics&DegreeType=Postgraduate"> PG</a></li>
                                                                                </ul>
                                                                            </div>
                                                                        </li>


                                                                        <li class="desk-fireing">
                                                                            <a href="/program-listing/?Country=Australia&categoryname=Commerce %26 Finance&DegreeType=all"  onMouseOver={()=>this.bussinesFunction2()} 
                                                                            onClick={() => {
                                                                                ReactGA.event({
                                                                                    category: "Home Page",
                                                                                    action: "Clicks",
                                                                                    label: "Programs - Australia - CommerceFinance"
                                                                                })
                                                                            }}
                                                                            id="nearbyfire2">Commerce & Finance  <img src="https://res.cloudinary.com/worldgrad/image/upload/v1612202440/worldgrad/right-arrow_ny7ss3.svg" alt="" /></a>
                                                                            <div id="price-menu2" class="explore-price-menu">
                                                                                <ul>
                                                                                    <li><a href="/program-listing/?Country=Australia&categoryname=Commerce %26 Finance&DegreeType=Undergraduate"
                                                                                    onClick={() => {
                                                                                        ReactGA.event({
                                                                                            category: "Home Page",
                                                                                            action: "Clicks",
                                                                                            label: "Programs - Australia - Commerce & Finance - UG"
                                                                                        })
                                                                                    }}>UG</a></li>
                                                                                    <li><a href="/program-listing/?Country=Australia&categoryname=Commerce %26 Finance&DegreeType=Postgraduate"
                                                                                    onClick={() => {
                                                                                        ReactGA.event({
                                                                                            category: "Home Page",
                                                                                            action: "Clicks",
                                                                                            label: "Programs - Australia - Commerce & Finance - PG"
                                                                                        })
                                                                                    }}> PG</a></li>
                                                                                </ul>
                                                                            </div>
                                                                        </li>


                                                                            <li class="mob-fireing"><a href="/program-listing/?Country=Australia&categoryname=Commerce %26 Finance&DegreeType=all" >Commerce & Finance  </a>  
                                                                            <img src="https://res.cloudinary.com/worldgrad/image/upload/v1612202440/worldgrad/right-arrow_ny7ss3.svg" alt="" onClick={()=>this.bussinesFunction2mob()} id="nearbyfire2" class="business-arrow" />
                                                                            <div id="price-menu2-mob" class="explore-price-menu">
                                                                                <ul>
                                                                                    <li><a href="/program-listing/?Country=Australia&categoryname=Commerce %26 Finance&DegreeType=Undergraduate">UG</a></li>
                                                                                    <li><a href="/program-listing/?Country=Australia&categoryname=Commerce %26 Finance&DegreeType=Postgraduate"> PG</a></li>
                                                                                </ul>
                                                                            </div>
                                                                        </li>


                                                                        <li class="desk-fireing"><a href="/program-listing/?Country=Australia&categoryname=Hospitality %26 Tourism&DegreeType=all" 
                                                                        onClick={() => {
                                                                            ReactGA.event({
                                                                                category: "Home Page",
                                                                                action: "Clicks",
                                                                                label: "Programs - Australia - Hospitality & Tourism"
                                                                            })
                                                                        }}
                                                                        onMouseOver={()=>this.bussinesFunction3()} id="nearbyfire3">Hospitality & Tourism  
                                                                        <img src="https://res.cloudinary.com/worldgrad/image/upload/v1612202440/worldgrad/right-arrow_ny7ss3.svg" alt="" /></a>
                                                                            <div id="price-menu3" class="explore-price-menu">
                                                                                <ul>
                                                                                    <li><a href="/program-listing/?Country=Australia&categoryname=Hospitality %26 Tourism&DegreeType=Undergraduate"
                                                                                    onClick={() => {
                                                                                        ReactGA.event({
                                                                                            category: "Home Page",
                                                                                            action: "Clicks",
                                                                                            label: "Programs - Australia - Hospitality & Tourism - UG"
                                                                                        })
                                                                                    }}
                                                                                    >UG</a></li>
                                                                                    <li><a href="/program-listing/?Country=Australia&categoryname=Hospitality %26 Tourism&DegreeType=Postgraduate"
                                                                                    onClick={() => {
                                                                                        ReactGA.event({
                                                                                            category: "Home Page",
                                                                                            action: "Clicks",
                                                                                            label: "Programs - Australia - Hospitality & Tourism - PG"
                                                                                        })
                                                                                    }}
                                                                                    > PG</a></li>
                                                                                </ul>
                                                                            </div>
                                                                        </li>


                                                                        <li class="mob-fireing"><a href="/program-listing/?Country=Australia&categoryname=Hospitality %26 Tourism&DegreeType=all" >Hospitality & Tourism   </a> 
                                                                        <img src="https://res.cloudinary.com/worldgrad/image/upload/v1612202440/worldgrad/right-arrow_ny7ss3.svg" onClick={()=>this.bussinesFunction3mob()} id="nearbyfire3" class="business-arrow" alt="" />
                                                                            <div id="price-menu3-mob" class="explore-price-menu">
                                                                                <ul>
                                                                                    <li><a href="/program-listing/?Country=Australia&categoryname=Hospitality %26 Tourism&DegreeType=Undergraduate">UG</a></li>
                                                                                    <li><a href="/program-listing/?Country=Australia&categoryname=Hospitality %26 Tourism&DegreeType=Postgraduate"> PG</a></li>
                                                                                </ul>
                                                                            </div>
                                                                        </li>


                                                                        <li><a href="/program-listing/?Country=Australia&categoryname=Sports %26 Event Management&DegreeType=Undergraduate" 
                                                                        onClick={() => {
                                                                            ReactGA.event({
                                                                                category: "Home Page",
                                                                                action: "Clicks",
                                                                                label: "Programs - Australia - Sports & EventManagement"
                                                                            })
                                                                        }}
                                                                        onMouseEnter={()=>this.sportsFunction()} id="Sprtsfunction" >Sports & Event Management </a></li>
                                                                        <li><a href="/program-listing/?Country=Australia&categoryname=Technology&DegreeType=Undergraduate" 
                                                                        onClick={() => {
                                                                            ReactGA.event({
                                                                                category: "Home Page",
                                                                                action: "Clicks",
                                                                                label: "Programs - Australia - Technology"
                                                                            })
                                                                        }}
                                                                        onMouseEnter={()=>this.techFunction()} id="tech-function" >Technology</a></li>
                                                                    </ul>  
                                                                </div>
                                                            </li>

                                                             <li>
                                                                <a href="/program-listing/?Country=Dubai&categoryname=all&DegreeType=all" 
                                                                onClick={() => {
                                                                    ReactGA.event({
                                                                        category: "Home Page",
                                                                        action: "Clicks",
                                                                        label: "Programs - Dubai"
                                                                    })
                                                                }}
                                                                onMouseOver={()=>this.myFunction2()} id="fireing1" class="desk-fireing">UAE
                                                                <img src="https://res.cloudinary.com/worldgrad/image/upload/v1612202440/worldgrad/right-arrow_ny7ss3.svg" alt="" /></a>
                                                                <a href="/program-listing/?Country=Dubai&categoryname=all&DegreeType=all" class="mob-fireing widh-ext">UAE </a> 
                                                                <img src="https://res.cloudinary.com/worldgrad/image/upload/v1612202440/worldgrad/right-arrow_ny7ss3.svg" class="aus-arrow" onClick={()=>this.myFunction2()} id="fireing1" alt="" />
                                                                

                                                                

                                                                <div id="explore-country2" class="explore-country">
                                                                    <ul>
                                                                        <li class="desk-fireing"><a href="/program-listing/?Country=Dubai&categoryname=Business %26 Analytics&DegreeType=all" 
                                                                        onClick={() => {
                                                                            ReactGA.event({
                                                                                category: "Home Page",
                                                                                action: "Clicks",
                                                                                label: "Programs - Dubai - Business & Analytics"
                                                                            })
                                                                        }}
                                                                        onMouseOver={()=>this.analyticFunction()}  id="nearbyfire4">Business & Analytics  <img src="https://res.cloudinary.com/worldgrad/image/upload/v1612202440/worldgrad/right-arrow_ny7ss3.svg" alt="" /></a>
                                                                            <div id="price-menu4" class="explore-price-menu">
                                                                                <ul>
                                                                                    <li><a href="/program-listing/?Country=Dubai&categoryname=Business %26 Analytics&DegreeType=Undergraduate"
                                                                                    onClick={() => {
                                                                                        ReactGA.event({
                                                                                            category: "Home Page",
                                                                                            action: "Clicks",
                                                                                            label: "Programs - Dubai - Business & Analytics - UG"
                                                                                        })
                                                                                    }}
                                                                                    >UG</a></li>
                                                                                    {/* <li><a href="/program-listing/?Country=Dubai&categoryname=Business %26 Analytics&DegreeType=Postgraduate"> PG</a></li> */}
                                                                                </ul>
                                                                            </div>
                                                                        </li>


                                                                         <li class="mob-fireing"><a href="/program-listing/?Country=Dubai&categoryname=Business %26 Analytics&DegreeType=all">Business & Analytics   </a>
                                                                         <img src="https://res.cloudinary.com/worldgrad/image/upload/v1612202440/worldgrad/right-arrow_ny7ss3.svg" onClick={()=>this.analyticFunctionmob()} id="nearbyfire4" class="business-arrow" alt="" />
                                                                            <div id="price-menu4-mob" class="explore-price-menu">
                                                                                <ul>
                                                                                    <li><a href="/program-listing/?Country=Dubai&categoryname=Business %26 Analytics&DegreeType=Undergraduate">UG</a></li>
                                                                                    {/* <li><a href="/program-listing/?Country=Dubai&categoryname=Business %26 Analytics&DegreeType=Postgraduate"> PG</a></li> */}
                                                                                </ul>
                                                                            </div>
                                                                        </li>


                                                                        <li><a href="/program-listing/?Country=Dubai&categoryname=Commerce %26 Finance&DegreeType=Undergraduate"
                                                                        onClick={() => {
                                                                            ReactGA.event({
                                                                                category: "Home Page",
                                                                                action: "Clicks",
                                                                                label: "Programs - Dubai - Commerce & Finance"
                                                                            })
                                                                        }} onMouseOver={()=>this.DubaiCommerceFun()} id="Dubaicommerce"> Commerce & Finance </a></li>
                                                                    </ul>  
                                                                </div>
                                                            </li>
                                                            <li>
                                                                <a href="/program-listing/?Country=United kingdom&categoryname=all&DegreeType=all" onMouseOver={()=>this.myFunction3()} id="fireing3" class="desk-fireing">UK
                                                                <img src="https://res.cloudinary.com/worldgrad/image/upload/v1612202440/worldgrad/right-arrow_ny7ss3.svg" alt="" /></a>
                                                                <a href="/program-listing/?Country=United kingdom&categoryname=all&DegreeType=all" 
                                                                onClick={() => {
                                                                    ReactGA.event({
                                                                        category: "Home Page",
                                                                        action: "Clicks",
                                                                        label: "Programs - UnitedKingdom"
                                                                    })
                                                                }}
                                                                class="mob-fireing widh-ext" >UK  </a>
                                                                <img src="https://res.cloudinary.com/worldgrad/image/upload/v1612202440/worldgrad/right-arrow_ny7ss3.svg" onClick={()=>this.myFunction3()} id="fireing3" class="aus-arrow" alt="" />
                                                               

                                                                 

                                                                <div id="explore-country3" class="explore-country">
                                                                    <ul>
                                                                        <li><a href="/program-listing/?Country=United kingdom&categoryname=Business %26 Analytics&DegreeType=Undergraduate"
                                                                        onClick={() => {
                                                                            ReactGA.event({
                                                                                category: "Home Page",
                                                                                action: "Clicks",
                                                                                label: "Programs - United Kingdom - Business & Analytics"
                                                                            })
                                                                        }} onMouseOver={()=>this.UkBusinessFunction()}id="UkBussiness">Business & Analytics</a></li>
                                                                        <li><a href="/program-listing/?Country=United kingdom&categoryname=Commerce %26 Finance&DegreeType=Undergraduate"
                                                                        onClick={() => {
                                                                            ReactGA.event({
                                                                                category: "Home Page",
                                                                                action: "Clicks",
                                                                                label: "Programs - United Kingdom - Commerce & Finance"
                                                                            })
                                                                        }}
                                                                        onMouseOver={()=>this.UkCommerceFunction()} id="UkCommerce">Commerce & Finance</a></li>
                                                                    </ul>  
                                                                </div>
                                                            </li>




                                                            <li>
                                                                <a href="/english-preparation" id="fireing4" 
                                                                onClick={() => {
                                                                    ReactGA.event({
                                                                        category: "Home Page",
                                                                        action: "Clicks",
                                                                        label: "Programs - English Preparation"
                                                                    })
                                                                }}
                                                                onMouseOver={()=>this.EngishPrep()} >English Preparation</a>
                                                              
                                                            </li>





                                                        </ul>
                                                    </div>
                                                </div>



                                    </li>   
                                            <li class="nav-item" onMouseEnter={() => this.InstitutionsFunction()}>
                                                                        <a class="nav-link"  onClick={() => {
                                            ReactGA.event({
                                                category: "Home Page",
                                                action: "Clicks",
                                                label: "Institutions"
                                            })
                                                }}> Institutions<img src="https://media.publit.io/file/TheWorldgrad/HeaderCommon/down-arrow_hndcah.svg" alt="" /></a>
                                                                                <div class="submenu">
                                            <ul class="countries-list">
                                                <li>
                                                    <a 
                                                        href="/universities/australia"
                                                        onClick={() => {
                                                            ReactGA.event({
                                                                category: "Home Page",
                                                                action: "Filter>Clicks",
                                                                label: "About The WorldGrad"
                                                            })
                                                        }}
                                                    >
                                                        AUSTRALIA
                                                    </a>
                                                </li>
                                                <li>
                                                    <a 
                                                        href="/universities/uae"
                                                        onClick={() => {
                                                            ReactGA.event({
                                                                category: "Home Page",
                                                                action: "Filter>Clicks",
                                                                label: "FAQ"
                                                            })
                                                        }}
                                                    >   
                                                        UAE
                                                    </a>
                                                </li>
                                                <li>
                                                    <a 
                                                        href="/universities/united-kingdom"
                                                        onClick={() => {
                                                            ReactGA.event({
                                                                category: "Home Page",
                                                                action: "Filter>Clicks",
                                                                label: "Partner With Us"
                                                            })
                                                        }}
                                                    >
                                                        UK
                                                    </a>
                                                </li>
                                                <li>
                                                    <a 
                                                        href="/universities/usa"
                                                        onClick={() => {
                                                            ReactGA.event({
                                                                category: "Home Page",
                                                                action: "Filter>Clicks",
                                                                label: "About The WorldGrad"
                                                            })
                                                        }}
                                                    >
                                                        USA
                                                    </a>
                                                </li>
                                                {/* <li><a href="/blogs">BLOGS & RESOURCES</a></li> */}
                                            </ul>
                                        </div>

                                    </li>  


                                            <li class="nav-item" onMouseEnter={() => this.InstitutionsFunction()}>
                                        <a class="nav-link"  onClick={() => {
                                            ReactGA.event({
                                                category: "Home Page",
                                                action: "Clicks",
                                                label: "Countries"
                                            })
                                                }}>  countries<img src="https://media.publit.io/file/TheWorldgrad/HeaderCommon/down-arrow_hndcah.svg" alt="" /></a>
                                                                                <div class="submenu">
                                                    <ul class="countries-list">
                                                        <li>
                                                            <a href="/countries/australia"
                                                                onClick={() => {
                                                                    ReactGA.event({
                                                                        category: "Home Page",
                                                                        action: "Filter>Clicks",
                                                                        label: "About The WorldGrad"
                                                                    })
                                                                }}
                                                            >
                                                                AUSTRALIA
                                                            </a>
                                                        </li>
                                                        <li>
                                                            <a
                                                                href="/countries/uae"
                                                                onClick={() => {
                                                                    ReactGA.event({
                                                                        category: "Home Page",
                                                                        action: "Filter>Clicks",
                                                                        label: "FAQ"
                                                                    })
                                                                }}
                                                            >
                                                                UAE
                                                            </a>
                                                        </li>
                                                        <li>
                                                            <a
                                                                href="/countries/united-kingdom"
                                                                onClick={() => {
                                                                    ReactGA.event({
                                                                        category: "Home Page",
                                                                        action: "Filter>Clicks",
                                                                        label: "Partner With Us"
                                                                    })
                                                                }}
                                                            >
                                                                UK
                                                            </a>
                                                        </li>
                                                        <li >
                                                            <a href="/countries/usa"
                                                                onClick={() => {
                                                                    ReactGA.event({
                                                                        category: "Home Page",
                                                                        action: "Filter>Clicks",
                                                                        label: "About The WorldGrad"
                                                                    })
                                                                }}
                                                            >
                                                                USA
                                                            </a>
                                                        </li>
                                                    </ul>
                                        </div>

                                    </li>  
                                    <li class="nav-item">
                                        <a class="nav-link" href="/study-resources/" onClick={() => {
                                            ReactGA.event({
                                                category: "Home Page",
                                                action: "Clicks",
                                                label: "Study Resources"
                                            })
                                        }}>Study Resources</a>
                                    </li>  
                                    {/* ---------- */}
                                     

                                    {/* -------------- */}
                                    <li class="nav-item">
                                                <a class="nav-link" href="#">more <img src="https://media.publit.io/file/TheWorldgrad/HeaderCommon/down-arrow_hndcah.svg" alt="" /></a>
                                        <div class="submenu">
                                            <ul>
                                                <li><a href="/about-us/"
                                                    onClick={() => {
                                                        ReactGA.event({
                                                            category: "Home Page",
                                                            action: "Filter>Clicks",
                                                            label: "About The WorldGrad"
                                                        })
                                                    }}
                                                >ABOUT THE WORLDGRAD</a></li>
                                                <li><a href="/partnership"
                                                    onClick={() => {
                                                        ReactGA.event({
                                                            category: "Home Page",
                                                            action: "Filter>Clicks",
                                                            label: "Partner With Us"
                                                        })
                                                    }}
                                                >PARTNER WITH US</a></li>
                                                {/* <li><a href="/blogs">BLOGS & RESOURCES</a></li> */}
                                                <li><a href="/faq/"
                                                    onClick={() => {
                                                        ReactGA.event({
                                                            category: "Home Page",
                                                            action: "Filter>Clicks",
                                                            label: "FAQ"
                                                        })
                                                    }}
                                                >FAQS</a></li>
                                            </ul>
                                        </div>
                                    </li>   
                                </ul> 
                                <div class="header-right">
                                    <ul>
                                        {/* <li onClick={()=> this.hamFunction()}>
                                            <a onClick={() => {
                                                this.handlePopupWindow()
                                                ReactGA.event({
                                                    category: "Home Page",
                                                    action: "Clicks",
                                                    label: "Enquire"
                                                })
                                            }}>Enquire</a>
                                        </li> */}
                                        <li><a href="https://studentportal.theworldgrad.com" target="_blank" onClick={() => {
                                            ReactGA.event({
                                                category: "Home Page",
                                                action: "Clicks",
                                                label: "Applications"
                                            })
                                        }}>Applications</a></li>
                                    </ul>
                                </div>
                            </div>
                        </nav>
                    </div>
                </div>
            </div>
        </div>
        </header>
        </div>
    )

    
  }
}
export default Header;
